import React from 'react'
import { QueryClient, dehydrate } from '@tanstack/react-query'
import { GetStaticProps } from 'next'

import { Homepage } from '@mindfulchefuk/features/Homepage/Homepage'
import { THomepage } from '@mindfulchefuk/features/Homepage/interfaces'
import {
  HomepageContextProvider,
  useHomepageContext,
} from '@mindfulchefuk/context/HomepageContext/HomepageContext'
import { NextPageWithLayout } from '@mindfulchefuk/types/NextJS'
import { HomepageLayout } from '@mindfulchefuk/features/Homepage/components'
import Loader from '@mindfulchefuk/components/Loader'
import { getCMSHomepageContent } from '@mindfulchefuk/features/CMS/services/getCMSHomepageContent'

export const Index: NextPageWithLayout = (props: THomepage) => {
  const {
    heroImageDesktop,
    heroImageMobile,
    heroTrustpilotBannerDesktop,
    heroTrustpilotBannerMobile,
    heroRecipeBoxImage,
  } = props

  const { isLoading: isLoadingHomepageData } = useHomepageContext()
  const isLoading =
    isLoadingHomepageData ||
    !heroImageDesktop ||
    !heroImageMobile ||
    !heroTrustpilotBannerDesktop ||
    !heroTrustpilotBannerMobile ||
    !heroRecipeBoxImage

  if (isLoading) {
    return <Loader />
  }

  return (
    <Homepage
      heroImageDesktop={heroImageDesktop}
      heroImageMobile={heroImageMobile}
      heroTrustpilotBannerDesktop={heroTrustpilotBannerDesktop}
      heroTrustpilotBannerMobile={heroTrustpilotBannerMobile}
      heroRecipeBoxImage={heroRecipeBoxImage}
    />
  )
}

Index.getLayout = (page) => (
  <HomepageLayout>
    <HomepageContextProvider>{page}</HomepageContextProvider>
  </HomepageLayout>
)

export default Index

export const getStaticProps: GetStaticProps = async () => {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery({
    queryKey: ['cms-page-homepage'],
    queryFn: getCMSHomepageContent,
  })

  const heroImageDesktop =
    'https://mindfulchef-images-production.imgix.net/homepage/StaticHeroDesktop.png'
  const heroImageMobile =
    'https://mindfulchef-images-production.imgix.net/homepage/StaticHeroImageMobile.png'
  const heroTrustpilotBannerDesktop =
    'https://mindfulchef-images-production.imgix.net/homepage/HeroTrustpilotBannerDesktop.png'
  const heroTrustpilotBannerMobile =
    'https://mindfulchef-images-production.imgix.net/homepage/HeroTrustpilotMobileBanner.png'
  const heroRecipeBoxImage =
    'https://mindfulchef-images-production.imgix.net/homepage/HeroRecipeBoxWithVegetables.png'

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      heroImageDesktop,
      heroImageMobile,
      heroTrustpilotBannerDesktop,
      heroTrustpilotBannerMobile,
      heroRecipeBoxImage,
    },
    revalidate: parseInt(process.env.NEXT_PUBLIC_CMS_REVALIDATE_INTERVAL, 10),
  }
}
